import { SimpleGrid as MantineSimpleGrid } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import styles from "./simple-grid.module.scss";
import type { CustomSimpleGridFactory, IProps } from "./simple-grid.types";

const SimpleGrid = componentWrapper<CustomSimpleGridFactory, IProps>("Grid", (props, ref) => {
    return (
        <MantineSimpleGrid ref={ref} classNames={{ root: styles["root"], container: styles["container"] }} {...props} />
    );
});

export { SimpleGrid };
